export const SAMPLE_RESUME_DATA = {
  full_name: "Alex Morgan",
  target_role: "Salesforce Data Cloud Consultant",
  contact_email: "alex.morgan@email.com",
  contact_phone: "+1 555 200 3000",
  location: "Austin, TX",
  summary: "Results-driven Salesforce professional with 5+ years delivering Data Cloud, SFMC, and Flow automation solutions for enterprise clients.",
  skills: ["Data Cloud", "SOQL", "Apex", "Flow Builder", "SFMC", "Identity Resolution"],
  experience: [
    {
      title: "Salesforce Consultant", company: "CloudPeak Solutions",
      start_date: "Jan 2021", end_date: "", current: true,
      bullets: ["Led Data Cloud implementation for 3 enterprise clients", "Reduced data unification time by 40% via automation"],
    },
  ],
  education: [{ degree: "B.S.", field: "Computer Science", school: "University of Texas", start_date: "2015", end_date: "2019" }],
};

const ALL_TRACKS = ["data_cloud", "sfmc", "mc_next"];

export const GALLERY_TEMPLATES = [
  { id: "modern", colorId: "indigo", name: "Modern Professional", style: "Modern", roleLevel: ["Entry", "Mid"], tracks: ALL_TRACKS, badge: "Popular" },
  { id: "classic", colorId: "slate", name: "Classic Traditional", style: "Classic", roleLevel: ["Mid", "Senior"], tracks: ALL_TRACKS },
  { id: "minimal", colorId: "sky", name: "Minimal Clean", style: "ATS-Friendly", roleLevel: ["Entry"], tracks: ALL_TRACKS, badge: "New" },
  { id: "timeline", colorId: "emerald", name: "Career Timeline", style: "ATS-Friendly", roleLevel: ["Mid", "Senior"], tracks: ALL_TRACKS },
  { id: "dark", colorId: "indigo", name: "Dark Executive", style: "Classic", roleLevel: ["Senior", "Architect"], tracks: ALL_TRACKS, badge: "Popular" },
  { id: "sidebar", colorId: "rose", name: "Sidebar Spotlight", style: "Creative", roleLevel: ["Mid", "Senior"], tracks: ALL_TRACKS },
  { id: "photo", colorId: "sky", name: "Photo Header", style: "Creative", roleLevel: ["Entry", "Mid"], tracks: ALL_TRACKS },
  { id: "twocol", colorId: "amber", name: "Two-Column Split", style: "Modern", roleLevel: ["Mid", "Senior"], tracks: ALL_TRACKS },
  { id: "geometric", colorId: "rose", name: "Bold Geometric", style: "Creative", roleLevel: ["Entry", "Mid"], tracks: ALL_TRACKS, badge: "New" },
  { id: "banner", colorId: "sky", name: "Banner Bold", style: "Modern", roleLevel: ["Entry", "Mid"], tracks: ALL_TRACKS, badge: "New" },
  { id: "compact", colorId: "emerald", name: "Compact Grid", style: "ATS-Friendly", roleLevel: ["Entry", "Mid", "Senior"], tracks: ALL_TRACKS },
  { id: "corporate", colorId: "slate", name: "Corporate Formal", style: "Classic", roleLevel: ["Senior", "Architect"], tracks: ALL_TRACKS, badge: "Popular" },
  { id: "skillbars", colorId: "indigo", name: "Skill Bars", style: "Creative", roleLevel: ["Mid", "Senior"], tracks: ALL_TRACKS, badge: "New" },
  { id: "diagonal", colorId: "rose", name: "Diagonal Edge", style: "Creative", roleLevel: ["Entry", "Mid"], tracks: ALL_TRACKS },
  { id: "monogram", colorId: "amber", name: "Monogram Boxed", style: "Modern", roleLevel: ["Entry", "Mid", "Senior"], tracks: ALL_TRACKS },
];
